import React from 'react';
import PropTypes from 'prop-types';
import { createMicroFrontend } from '@zillow/frontier';
import { getIsMobileMode } from '@zillow/home-details-double-scroll-style-guide';
import MstHomeDetailsGoogleAds, { AD_TYPE } from './MstHomeDetailsGoogleAds';

function createAdsBlock(
    targets,
    variant,
    targetDiv,
    versOn,
    isIAB,
    isPrebidAllowed,
    isMobile,
    isTablet,
    isAdsOn,
    guid
) {
    return (
        <div className="ad-frame-container">
            <MstHomeDetailsGoogleAds
                targets={targets}
                variant={variant}
                isPrebidAllowed={isPrebidAllowed}
                isIAB={isIAB}
                versOn={versOn}
                targetDiv={targetDiv}
                adType={AD_TYPE.GENERIC_CENTER_AD}
                eventName="Footer"
                isMobile={isMobile}
                isTablet={isTablet}
                isAdsOn={isAdsOn}
                guid={guid}
            />
        </div>
    );
}

function MstHomeDetailsMainAds({
    targets,
    variant,
    versOn,
    isIAB,
    isPrebidAllowed,
    isMobile,
    isTablet,
    isAdsOn,
    guid,
}) {
    // Do not show any ad in fullpage, mobile or tablet view.
    // display 2 medium ads in lightbox view
    return !getIsMobileMode() ? (
        <div data-testid="google-ads-main-content" className="ad home-details-lightbox-bottom-ad">
            {createAdsBlock(
                targets,
                variant,
                'hdp_iab_slot_box_1',
                versOn,
                isIAB,
                isPrebidAllowed,
                isMobile,
                isTablet,
                isAdsOn,
                guid
            )}
            {createAdsBlock(
                targets,
                variant,
                'hdp_iab_slot_box_2',
                versOn,
                isIAB,
                isPrebidAllowed,
                isMobile,
                isTablet,
                isAdsOn,
                guid
            )}
        </div>
    ) : null;
}

MstHomeDetailsMainAds.defaultProps = {
    isIAB: true,
    isMobile: false,
    isTablet: false,
    isAdsOn: true,
    guid: '',
};

MstHomeDetailsMainAds.propTypes = {
    targets: PropTypes.object,
    versOn: PropTypes.string,
    isPrebidAllowed: PropTypes.bool,
    isIAB: PropTypes.bool,
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isAdsOn: PropTypes.bool,
    guid: PropTypes.string,
    variant: PropTypes.string,
};

const MstFooterAd = createMicroFrontend({
    Component: MstHomeDetailsMainAds,
    onMicroFrontendLoad() {
        console.log('success load');
    },
    onMicroFrontendLoadError() {
        console.error('error loading');
    },
    fetchData: async () => {},
    getGraphQLFragments: () => {},
});

export default MstFooterAd;
